import React from 'react'
import AddOutlined from '@material-ui/icons/AddOutlined'

export default function AddOutlinedIcon({ ...other }) {

    return (
        <AddOutlined {...other} />
    )
}